import { CheckCircle2, CalendarClock } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { WhatsAppButton, QuoteButton } from "@/components/CtaButtons";
import { business } from "@/config/business";

const PM_INCLUDES = [
  "Pemeriksaan rutin",
  "Cleaning berkala",
  "Preventive maintenance",
  "Condition assessment",
  "Dokumentasi pekerjaan",
  "Riwayat maintenance",
  "Maintenance planning",
];

export const PreventiveMaintenanceSection = () => {
  return (
    <section
      id="preventive-maintenance"
      data-testid="preventive-maintenance-section"
      className="relative overflow-hidden bg-[#0F172A] py-20 sm:py-24 lg:py-28"
    >
      <div className="absolute -right-24 top-0 h-72 w-72 rounded-full bg-[#E0A400]/10 blur-3xl" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[1fr_1fr] lg:gap-16">
          <div>
            <Reveal>
              <div className="mb-4 flex items-center gap-3">
                <span className="text-sm font-bold text-[#E0A400]">05</span>
                <span className="text-sm font-bold uppercase tracking-[0.2em] text-slate-400">
                  Preventive Maintenance
                </span>
              </div>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="text-3xl font-extrabold leading-[1.12] tracking-tight text-white sm:text-4xl">
                SEJUKARA Preventive Maintenance
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-4 text-lg font-semibold text-[#E0A400]">
                Jangan Tunggu Rusak. Jadwalkan Perawatan.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-5 text-base leading-relaxed text-slate-300">
                Program perawatan berkala yang terencana untuk membantu menjaga
                performa AC & HVAC, serta mendukung kelancaran operasional.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <QuoteButton label={business.cta.primary} source="preventive_maintenance" size="lg" variant="accent" testId="pm-quote-cta" className="!bg-[#25D366] !text-white hover:!bg-[#1eb85a]" />
                <WhatsAppButton label={business.cta.secondary} message={business.whatsappMessages.b2b} source="preventive_maintenance" size="lg" testId="pm-whatsapp-cta" className="!bg-transparent !text-white ring-1 ring-inset ring-white/25 hover:!bg-white/10" />
              </div>
            </Reveal>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:self-center">
            {PM_INCLUDES.map((item, i) => (
              <Reveal key={item} delay={i * 0.05}>
                <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.03] p-4">
                  <CheckCircle2 className="h-5 w-5 flex-none text-[#E0A400]" />
                  <span className="text-sm font-semibold text-slate-200">{item}</span>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.35}>
              <div className="flex items-center gap-3 rounded-xl border border-[#E0A400]/30 bg-[#E0A400]/10 p-4">
                <CalendarClock className="h-5 w-5 flex-none text-[#E0A400]" />
                <span className="text-sm font-semibold text-white">Terjadwal & terdokumentasi</span>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PreventiveMaintenanceSection;
